import { PdvService } from './../../services/pdv/pdv.service';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { OrdersService } from '@app/services/order/orders.service';

@Component({
    selector: 'menu-card',
    templateUrl: 'menu.component.html',
    styleUrls: ['menu.component.scss']
})

export class MenuComponent{

    @Input()
    menu;
    loadAvatar = false;
    @Output()
    OnAdd:EventEmitter<boolean>=new EventEmitter<boolean>(); 
    addToBasket(){
        this.OnAdd.emit(true);
    }
    siteClose = false;
    subscriptions2: Subscription[] = [];
    orderName:string="";
    constructor(private pdvService:PdvService,private orderService:OrdersService){
    }
    ngOnInit(){
        let sub=this.pdvService.pdv.subscribe(
            (data)=>{
                this.siteClose=data.closeSite;
            }
        )
        this.subscriptions2.push(sub);
    }
    
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }
}
